// extracted by mini-css-extract-plugin
export var mainImageContainer = "pressReleasePage-module--mainImageContainer--8oO2M";